/**
 * @property resultsContainer The selector of the container the response will be added to.
 * @property ignoreEmpty If this is set to true and the input value of searchField is empty, no request will be sent.
 */
;(function($, window, document, undefined) {
	"use strict";

	var defaults   = {
		resultsContainer: null,
		monitorSelector: "",
		searchUrl: "search.php",
		searchVar: null,
		searchField: null,
		ignoreEmpty: false,
		searchData: {},
		onSearchStart: function() {},
		onSearchComplete: function() {}
	};

	function quickSearch(element, options) {
		this.timeout  = false;
		this.request  = false;
		this.element  = element;
		this.settings = $.extend({}, defaults, options);
		this.init();
	}

	$.extend(quickSearch.prototype, {
		init: function() {
			this.$monitorElement = this.settings.monitorSelector == '' ? $(this.element) : $(this.element).find(this.settings.monitorSelector);

			if (this.$monitorElement.filter('select,input').length > 0) {
				this.$monitorElement = this.$monitorElement.filter('select,input');
			} else {
				this.$monitorElement = this.$monitorElement.find('select,input');
			}

			this.loadResults();
			this.monitor();
		},

		monitor: function() {
			var self = this;

			if (self.timeout != false) {
				clearTimeout(self.timeout);
			}

			this.$monitorElement.filter('input[type=text], input[type=email], input[type=search]').on('input', function() {
				self.timeout = setTimeout(self.loadResults(), 200);
			});

			this.$monitorElement.filter('input[type=checkbox], input[type=radio], input[type=hidden], select').on('change', function() {
				self.timeout = setTimeout(self.loadResults(), 200);
			});
		},

		loadResults: function() {
			var self       = this;
			var searchVal  = this.settings.searchField ? this.settings.searchField.val() : '';
			var searchData = this.settings.searchData;
			var formData   = $(this.element).serializeArray();

			if (!$(this.element).first().is('form')) {
				formData = $(this.element).find('input, select, textarea').serializeArray();
			}

			if (this.settings.ignoreEmpty && searchVal === '') {
				return;
			}

			if (typeof searchData == 'string') {
				searchData = $(searchData).serializeArray();

			} else if (typeof searchData == 'object') {
				var searchDataNew = [];

				for (var key in searchData) {
					searchDataNew.push({
						name: key,
						value: searchData[key]
					});
				}

				searchData = searchDataNew;
			}

			for (key in formData) {
				searchData.push(formData[key]);
			}

			if (typeof this.request.abort == 'function') {
				this.request.abort();
			}

			this.settings.onSearchStart();
			this.request = $.ajax({
				url: this.settings.searchUrl,
				data: searchData
			}).done(function(data) {
				if (typeof(data) === 'string' && self.settings.resultsContainer) {
					self.settings.resultsContainer.html(data);
				}

				self.settings.onSearchComplete(data);
			});
		}
	});

	$.fn['quickSearch'] = function(options) {
		return this.each(function() {
			if (!$.data(this, "quickSearch")) {
				$.data(this, "quickSearch", new quickSearch(this, options));
			}
		});
	};

})(jQuery, window, document);
